const formatTrimToUpper = (value) => {
  if (!value) {
    return value;
  }
  
  return value.toUpperCase().trim();
};

export default formatTrimToUpper;
